import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useAuth } from "@clerk/react";
import { api, setTokenGetter } from "@/lib/api";
import { resetFollowedFacts } from "@/components/FollowFact";

const MeCtx = createContext({ me: null, access: null, refresh: () => {} });
export const useMe = () => useContext(MeCtx);

export function MeProvider({ children }) {
  const { getToken, isSignedIn, isLoaded } = useAuth();
  setTokenGetter(isSignedIn ? getToken : null);
  const [me, setMe] = useState(null);
  const [access, setAccess] = useState(null);

  const refresh = useCallback(async () => {
    const { data } = await api.get("/me");
    setMe(data);
    setAccess("approved");
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (tz && data.timezone !== tz) api.patch("/me", { timezone: tz }).catch(() => {});
  }, []);

  useEffect(() => {
    const onGate = (e) => { setMe(null); setAccess(e.detail); };
    window.addEventListener("middle:approval-required", onGate);
    return () => window.removeEventListener("middle:approval-required", onGate);
  }, []);

  useEffect(() => {
    if (!isLoaded) return;
    resetFollowedFacts();
    if (isSignedIn) refresh().catch(() => setMe(null));
    else { setMe(null); setAccess(null); }
  }, [isLoaded, isSignedIn, refresh]);

  return <MeCtx.Provider value={{ me, access, refresh }}>{children}</MeCtx.Provider>;
}
